<template>
  <div>
    <el-form @submit.native.prevent="editContent" :inline="true">
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" multiple placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          v-model="model.chID"
          @change="getCourse"
          multiple
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select v-model="model.clID" multiple placeholder="三级分类">
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-card>
        <div>
          <h3>修改课程目录</h3>
          <el-form-item label="目录对应课程名称">
            <el-input v-model="model.conName"></el-input>
          </el-form-item>
          <el-form-item label="conID">
            <el-input v-model="model.conID"></el-input>
          </el-form-item>
          <div
            v-for="(item, index) in contents"
            :key="item.contentsId"
            style="display: flex"
          >
            <el-form-item label="目录ID">
              <el-input v-model="item.contId"></el-input>
            </el-form-item>
            <el-form-item label="目录名称">
              <el-input v-model="item.contName"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="delContentInput(index, item)"
                type="primary"
                icon="el-icon-delete"
                circle
              ></el-button>
            </el-form-item>
          </div>
          <el-button @click="addContentInput">新增一行</el-button>
        </div>
      </el-card>
      <el-form-item style="margin-top: 25px">
        <el-button type="primary" native-type="submit">点击修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      model: [],
      conID: "",
      conName: "",
      contents: [
        {
          contId: Date.now(),
          contName: "",
        },
      ],
    };
  },
  methods: {
    async editContent() {
      try {
        const params = {
          contents: this.contents,
          conName: this.model.conName,
          conID: this.model.conID,
          maID: this.model.maID,
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        const result = await this.$http.put(
          "/content/putcontent?_id=" + `${this.id}`,
          params
        );
        if (result.status == 200) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
          this.$router.push("/content/list");
        }
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },
    async delContent(contId) {
      try {
        //有数据 修改数据 update
        const result = await this.$http.delete(
          "/content/delcontent?conID=" + `${this.model.conID}&contId=${contId}`
        );
        if (result.status === 203) {
          this.$message({
            type: "success",
            message: result.data.msg,
          });
        }
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        //console.log(item);
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    //获取需要编辑的目录
    async getEditContent() {
      try {
        const result = await this.$http.get("/content/getedit", {
          params: { id: this.id },
        });
        this.contents = result.data.contents;
        this.model.maID = result.data.maID;
        this.model.chID = result.data.chID;
        this.model.coID = result.data.coID;
        this.model.clID = result.data.clID;
        this.model.conName = result.data.conName;
        this.model.conID = result.data.conID;
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },

    // 动态添加
    addContentInput(index) {
      try {
        this.contents.push({
          contId: Date.now(),
          contName: "",
        });
      } catch (error) {
        this.$message({
          type: "warning",
          message: error.message,
        });
      }
    },
    // 删除
    delContentInput(index, item) {
      try {
        console.log(item);
        this.contents.splice(index, 1);
        if (item.contId) {
          this.delContent(item.contId);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //生成目录名称conID
    /* createConID() {
      this.conID = Date.now();
    }, */
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.id && this.getEditContent(this.id);
  },
};
</script>
